import { BARE_METAL_NODES_OPTION_META_KEYS } from '../../../capabilities/bare-metal-nodes/fieldKeys';
import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { BareMetalSpec } from './schema';

const MODULE_FIELD_STRIPS: Record<string, (spec: BareMetalSpec) => BareMetalSpec> = {
  systemSetting: (spec) => ({
    ...spec,
    systemVolume: undefined,
    powerPolicy: undefined,
    provisioning: undefined,
    boot: undefined,
    account: undefined,
  }),
  network: (spec) => ({
    ...spec,
    network: undefined,
  }),
  bareMetalNodes: (spec) => {
    const nextOptionMeta = spec.optionMeta ? { ...spec.optionMeta } : undefined;
    if (nextOptionMeta) {
      delete nextOptionMeta[BARE_METAL_NODES_OPTION_META_KEYS.node];
    }
    return {
      ...spec,
      bmsNode: undefined,
      optionMeta: nextOptionMeta && Object.keys(nextOptionMeta).length > 0 ? nextOptionMeta : undefined,
    };
  },
  service: (spec) => ({
    ...spec,
    network: {
      ...spec.network,
      services: undefined,
    },
  }),
};

export function filterBareMetalSpecByEnabledModules(
  spec: BareMetalSpec,
  enabledModules?: Record<string, boolean>,
  skuType?: 'fixed' | 'custom',
): BareMetalSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}

export function isBareMetalModuleEnabled(
  moduleKey: string,
  enabledModules?: Record<string, boolean>,
  skuType?: 'fixed' | 'custom',
): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}
